import { defineMessages } from 'react-intl-next';

export const commentMessages: {
	addCommentOnMedia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewCommentsOnMedia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAndAddCommentsOnMedia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addCommentOnMedia: {
		id: 'fabric.editor.addCommentOnMedia',
		defaultMessage: 'Add comment',
		description: 'Add a comment for this media (image/video)',
	},
	viewCommentsOnMedia: {
		id: 'fabric.editor.viewCommentOnMedia',
		defaultMessage: 'View comments',
		description: 'View a existing comment for this media (image/video)',
	},
	viewAndAddCommentsOnMedia: {
		id: 'fabric.editor.viewAndAddCommentsOnMedia',
		defaultMessage: 'View and add comments',
		description: 'View and add comments for this image',
	},
});
